module.exports = __webpack_public_path__ + "img/collection-weddingRingsHammered.f9965f6.jpg";